let move_devices_dialog_submitted_template = `<div class="assign-devices"></div>
<h4>Assigned Device Information</h4>
<table class="table table-condensed">
    <tr>
        <th>Account</th>
        <td>{{account_name}}</td>
    </tr>
    <tr>
        <th>Product</th>
        <td>{{product_name}}</td>
    </tr>
    <tr>
        <th>Device Group Type</th>
        <td class="capitalize">{{devicegroup_type}}</td>
    </tr>
    <tr>
        <th>Device Group Name</th>
        <td>{{devicegroup_name}}</td>
    </tr>
    <tr>
        <th>Latest Deployment</th>
        <td>
            {{#if deployment_sha}}
            {{short_sha deployment_sha}} <br>
            {{#date_UTC}}{{deployment_date}}{{/date_UTC}}
            {{else}} 
            No Deployments for {{devicegroup_name}}
            {{/if}}
        </td>
    </tr>
</table>
<div class="modal-footer move-assign-devices">
    <button type="button" class="btn btn-link cancel" data-dismiss="modal">Done</button>
    <button type="button" class="to-code-editor btn btn-primary" data-dismiss="modal">Start Writing Code for assigned Device(s) </button>
</div>
</div>`;

export default move_devices_dialog_submitted_template;
